import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  private crumbs: any[] = [
    {
      en_fr: 'ministry.of.mines',
      url_en: 'https://www.ontario.ca/page/ministry-mines',
      url_fr: 'https://www.ontario.ca/fr/page/ministere-des-mines',
    },
    {
      en_fr: 'geology.ontario',
      url_en: 'https://www.hub.geologyontario.mines.gov.on.ca/',
      url_fr: 'https://www.platforme.geologyontario.mines.gov.on.ca/',
    },
    {
      en_fr: 'text.search',
      url_en: '',
      url_fr: '',
    }
  ]

  constructor() { }

  getBreadcrumbs(): Array<any> {
    return this.crumbs;
  }

  addBreadcrumb(crumb: any) {
    if(crumb) {
      this.crumbs.push(crumb)
    }
  }

  removeBreadcrumb() {
    if(this.getBreadcrumbs().length > 3) {
      this.crumbs.pop();
    }
  }
}
